import React from 'react'

const StockHistory = ({ loading, resPacket }) => {

    return (
        resPacket && resPacket?.length > 0 ?
         <div className="customTable" id="scroll">
            <table className="customTable w-100">
                <thead >
                    <tr>
                        <td>Item Title</td>
                        <td>Unit Title</td>
                        <td>Category</td>
                        <td>Sub Category</td>
                        <td>Purchase Price</td>
                        <td>Quantity</td>
                        <td>Total Amount</td>
                    </tr>
                </thead>
                <tbody className="body-scroll-custom">
                    {
                        resPacket && resPacket?.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td>{item.itemTitle}</td>
                                    <td>{item?.category}</td>
                                    <td>{item?.subcategory}</td>
                                    <td>{item.UOM}</td>
                                    <td>{item.purchasePriceValue?.toFixed(3)}</td>
                                    <td>{item.Quantity?.toFixed(3)}</td>
                                    <td>{(item.purchasePriceValue * item.Quantity).toFixed(3)}</td>
                                </tr>
                            );
                        })
                    }
                </tbody>

            </table>
        </div> :
        <div>No Records Available.</div>
    )
}

export default StockHistory